import { createReducer } from 'redux-act';
import { IUserReducer } from '../../types/user';
import {
  fetchPayoutAccountSuccessAction,
  getAvailableCurrenciesSuccessAction
} from '../../actions';

const initialState: IUserReducer = {
  payoutAccount: {
    loaded: false,
    id: '',
    userId: '',
    payPalEmail: '',
    ibanEnabled: false,
    iban: '',
    ibanNew: '',
    accountHolder: '',
    payPalEnabled: false,
    payPalClientId: '',
    payPalSecret: ''
  },
  availableCurrencies: []
};

export const user = createReducer<IUserReducer>({}, initialState);

user.on(fetchPayoutAccountSuccessAction, (state, payload) => ({
  ...state,
  payoutAccount: { loaded: true, ...payload }
}));

user.on(getAvailableCurrenciesSuccessAction, (state, payload) => ({
  ...state,
  availableCurrencies: payload
}));
